import { Flex, Text, Box } from "@chakra-ui/react";
import { t } from "i18next";
import { Avatar } from "../../user/Avatar";
import { User } from "../../../types";
import { useSlideInMenu } from "../../slideInMenu/hooks/useSlideInMenu";
import { useAccountData } from "../../../hooks/useAccountData";
import { useGetReaderNavigationContext } from "../../../screens/reader/hooks/useGetReaderNavigationContext";

export interface NewsCardAvatarProps {
  isVideoHub?: boolean;
  author: User;
}

export function NewsCardAvatar({
  isVideoHub = false,
  author: { name, avatar_tiny_url },
}: NewsCardAvatarProps) {
  const { openUserProfile } = useSlideInMenu();
  const accountData = useAccountData();
  const isUserProfileEnabled = accountData?.features?.["user_profile"];
  const navigationContext = useGetReaderNavigationContext({});

  const handleClick = (e: React.MouseEvent) => {
    if (isUserProfileEnabled) {
      e.preventDefault();
      e.stopPropagation();
      openUserProfile(name, navigationContext);
    }
  };

  return (
    <Box
      onClick={handleClick}
      cursor={isUserProfileEnabled ? "pointer" : "default"}
    >
      {isVideoHub ? (
        <Flex flexDirection="row" alignItems="center" gap="12px">
          <Avatar
            key={avatar_tiny_url}
            showRing={false}
            size="sm"
            username={name}
            imageSrc={avatar_tiny_url}
          />
          <Text variant="newsCardVital" fontFamily="Roboto" fontSize="12px">
            {name}
          </Text>
        </Flex>
      ) : (
        <Text variant="newsCardVital">
          {t("components.newsCards.by", { name })}
        </Text>
      )}
    </Box>
  );
}
